import { View, Text, Pressable, TouchableOpacity, useWindowDimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import Toast from 'react-native-toast-message';
import { impactLight, impactMedium } from '@/utils/haptic';
import Unicon from './Unicon';
import { StyleSheet } from 'react-native-unistyles';
import { useModalPortalContainer } from '@/data/store/useModalPortalStore';

let hideToast;


const CustomBaseToast = ({icon, colorVariant, text1Style, text2Style, text1, text2, onPress}) => {
    const visibilityTime = Math.max(text2?.length * 75, 5000)

    clearTimeout(hideToast)
    // eslint-disable-next-line react-compiler/react-compiler
    hideToast = setTimeout(() => {
        Toast.hide()
    }, visibilityTime)

    // On web, shift the toast left so it sits beside an open drawer instead
    // of behind it. The modal portal store tracks open modal DOM nodes; we
    // read the drawer width from the top-of-stack node.
    const modalNode = useModalPortalContainer();
    const { width: screenWidth } = useWindowDimensions();
    const [modalWidth, setModalWidth] = useState(0);

    useEffect(() => {
        setModalWidth(modalNode?.offsetWidth || 0);
    }, [modalNode]);

    // Only offset when there's room for the toast beside the drawer
    const shouldOffset = modalWidth > 0 && screenWidth - 30 - modalWidth >= 250;
    const toastWidth = shouldOffset
        ? Math.min(400, screenWidth - 30 - modalWidth)
        : undefined;

    const handleClose = () => {
        Toast.hide();
    }

    return <View style={[styles.toastWrapper, shouldOffset && { marginRight: modalWidth }]} >
        <Pressable
            onLongPress={() => {
                impactLight();
                clearTimeout(hideToast)
            }}
            onPress={onPress}
            style={[styles.toast, toastWidth != null && { width: toastWidth }]}
        >
            <View style={styles.innerToast(colorVariant)}>
                <View style={styles.toastIcon}>
                    <Unicon name={icon} size={30} colorVariant={colorVariant}/>
                </View>
                <View style={styles.textContainer}>
                    <Text style={styles.toastText1(text1Style)}>{text1}</Text>
                    <Text style={styles.toastText2(text2Style)}>{text2}</Text>
                </View>
                <TouchableOpacity testID="close-toast" onPressIn={handleClose} style={styles.toastIcon}>
                    <Unicon name={"close"} size={25} colorVariant={"textSecondary"}/>
                </TouchableOpacity>
            </View>
        </Pressable>
    </View>
}

export default function ReachToast() {

    useEffect(() => {
        // Add a delay feature to Toast for use in modals since the normal show will show immediately 
        // and will be lost before the user can see it
        if (typeof Toast.delayShow !== 'function') {
            Toast.delayShow = function(params, delay = 1000) {
                setTimeout(() => {
                    Toast.show(params);
                }, delay);
            };
        }
    }, []);

    const toastConfig = {
        success: (props) => <CustomBaseToast {...props} colorVariant={"success"} text1={props.text1 || "Success!"} icon="checkmark-circle-outline"/>,
        info: (props) => <CustomBaseToast {...props} colorVariant={"primary"} text1={props.text1 || "Heads Up"} icon="information-circle-outline"/>,
        error: (props) => <CustomBaseToast {...props} colorVariant={"error"} text1={props.text1 || "Uh-oh!"} icon="alert-circle-outline"/>,
        network: (props) => <CustomBaseToast {...props} colorVariant={props.props.disconnected ? "error" : "success"} text1={props.text1} icon="wifi"/>,
        notification: (props) => <CustomBaseToast {...props} colorVariant={"warning"} text1={props.text1 || "Notification"} icon="notifications-outline"/>
    };

    return (
        <Toast
            onShow={() => impactMedium()}
            onHide={() => clearTimeout(hideToast)}
            position="top"
            topOffset={70}
            bottomOffset={40}
            autoHide={false}
            swipeable
            zIndex={1000}
            config={toastConfig}
        />
    )
}

const styles = StyleSheet.create(({colors, shadows}, rt) => ({
    toastWrapper: {
        alignSelf:"flex-end",
        paddingHorizontal:15,
        zIndex: 1000
    },
    toast: {
        borderRadius:8, 
        overflow:"hidden", 
        width:rt.screen.width - 30,
        maxWidth:400,
        backgroundColor:colors.background, 
        boxShadow:shadows.card,
        borderColor:colors.border,
        borderWidth:1
    },
    innerToast: (colorVariant) => ({
        borderLeftWidth: 7,
        borderLeftColor: colors[colorVariant],
        paddingVertical:15,
        flexDirection:"row"
    }),
    toastIcon: {
        width:50, 
        alignItems:"center", 
        justifyContent:"center"
    },
    textContainer: {
        flex: 1, 
        justifyContent: "center"
    },
    toastText1: (style) => ({
        ...style,
        fontSize: 14,
        color:colors.text,
        fontWeight:"bold"
    }),
    toastText2: (style) => ({
        ...style,
        fontStyle:"italic",
        fontSize: 12,
        color:colors.text
    })
}))